import React, { useState } from "react";
import { StldInput } from '../../styled-components/StyledInput.style';

export const DynamicSelect = ({ placeholder, valuetext, label, name, options, keyValue, keyLabel, paramMethod, classNameCustom, clearOption = false, disabled = false }) => {

    const [focused, isFocused] = useState('');
    const [inputValue, getInputValue] = useState('');

    let classNameParam = classNameCustom ? classNameCustom : '';
    classNameParam += `${(focused === name || !!inputValue) && !disabled ? ' focused' : ''}`

    return (
        <StldInput onMouseEnter={() => isFocused(name)} onMouseLeave={() => isFocused(null)} >
            <label className={classNameParam}>{valuetext !== null ? valuetext : label}</label>
            <select disabled={disabled} name={name} value={valuetext} onChange={(event) => { paramMethod(inputValue, event.target.value) }} className={clearOption && valuetext != null ? 'select-clear' : ''}>
                <option value={"clear"} >{!!focused ? placeholder : ''}{placeholder}</option>
                {options.map((opt, iOpt) => <option key={iOpt} value={opt[keyValue]}>{opt[keyLabel]}</option>)}
            </select>
            {valuetext !== null && clearOption ? <span className="clear-btn" onClick={(event) => { paramMethod(null, null) }} ><svg width="13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg></span> : ""}
        </StldInput>
    )
}